type T = (value: string | URL) => URL;

const f: T = (value) => (value instanceof URL ? value : new URL(value));

export default f;
